import { useEffect } from 'react';
import { useRouter } from 'next/router';

export default function GraphicalAbstractMakerToolPage() {
  const router = useRouter();

  useEffect(() => {
    router.push('/graphical-abstract-maker');
  }, []);

  return null;
}
